import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const AboutPage: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="w-full bg-canvas text-text-primary">
            {/* Hero Section - vertically centered */}
            <section id="hero" className="relative w-full h-screen flex flex-col justify-center items-start px-6 md:px-16 lg:px-24 bg-black text-white">
                <h1 className="text-5xl md:text-7xl lg:text-8xl font-normal tracking-[-0.02em] text-white leading-[1.1] max-w-5xl">
                    About Nura
                </h1>
                <p className="mt-6 md:mt-8 ml-[3px] text-lg md:text-xl text-text-primary max-w-2xl">
                    Built by SilentLabs. Focused on cognitive performance.
                </p>
            </section>

            {/* Section 1 - matches ManifestoSection layout exactly */}
            <section className="relative w-full min-h-screen flex flex-col justify-center bg-canvas py-24 md:py-32">
                <div className="w-full px-6 md:px-24 lg:px-32 flex flex-col md:flex-row items-center gap-12 md:gap-16">
                    {/* Text Area */}
                    <div className="flex-1">
                        <h2 className="text-5xl md:text-7xl lg:text-8xl font-normal tracking-[-0.02em] text-text-primary mb-6 md:mb-8 leading-[1.1]">
                            SilentLabs
                        </h2>
                        <p className="text-lg md:text-xl text-text-primary max-w-2xl">
                            We build tools that connect you deeper to your own mind. Nura is our first product.
                        </p>
                        <Link
                            to="/technology"
                            className="mt-6 md:mt-8 inline-block text-lg text-text-primary whitespace-nowrap bg-transparent border border-primary px-5 py-2 rounded-full hover:bg-text-primary hover:text-canvas transition-colors focus-visible:outline-2 focus-visible:outline-text-primary focus-visible:outline-offset-4 focus:outline-none"
                        >
                            Explore Technology
                        </Link>
                    </div>

                    {/* Image Placeholder - matches ManifestoSection */}
                    <div
                        className="relative w-[100vw] md:w-full md:max-w-[600px] -mx-6 md:mx-0 aspect-square flex-shrink-0 rounded-none md:rounded-2xl overflow-hidden isolate"
                        style={{ transform: 'translateZ(0)', WebkitMaskImage: '-webkit-radial-gradient(white, black)' }}
                    >
                        <div className="absolute inset-0 w-full h-full bg-gradient-to-br from-[#1c1917] to-[#44403c]" />
                    </div>
                </div>
            </section>

            {/* Section 2 - matches ResearchSection layout exactly */}
            <section className="relative w-full min-h-screen flex flex-col justify-center bg-canvas text-text-primary py-24 md:py-32">
                <div className="w-full px-6 md:px-24 lg:px-32 flex flex-col md:flex-row items-center gap-12 md:gap-16">
                    {/* Text Area */}
                    <div className="flex-1">
                        <h2 className="text-5xl md:text-7xl lg:text-8xl font-normal tracking-[-0.02em] text-text-primary mb-6 md:mb-8 leading-[1.1]">
                            Privacy first
                        </h2>
                        <p className="text-lg md:text-xl text-text-primary max-w-2xl">
                            Your mental state is intimate data. We treat it with absolute sanctity.
                        </p>
                        <Link
                            to="/app"
                            className="mt-6 md:mt-8 inline-block text-lg text-text-primary whitespace-nowrap bg-transparent border border-primary px-5 py-2 rounded-full hover:bg-text-primary hover:text-canvas transition-colors focus-visible:outline-2 focus-visible:outline-text-primary focus-visible:outline-offset-4 focus:outline-none"
                        >
                            Try Now
                        </Link>
                    </div>

                    {/* Image Placeholder - matches ResearchSection */}
                    <div
                        className="relative w-[100vw] md:w-full md:max-w-[600px] -mx-6 md:mx-0 aspect-square flex-shrink-0 rounded-none md:rounded-2xl overflow-hidden isolate"
                        style={{ transform: 'translateZ(0)', WebkitMaskImage: '-webkit-radial-gradient(white, black)' }}
                    >
                        <div className="absolute inset-0 w-full h-full bg-gradient-to-br from-[#0f172a] to-[#1e3a8a]" />
                    </div>
                </div>
            </section>
        </main>
    );
};

export default AboutPage;
